<script>
import GroupAbstract from './group-abstract';

export default {
  mixins: [GroupAbstract],
  name: 'tracked-measurements-form-input-group-multiple',
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/persons/participants/participant-evolution/measurement/tracked-measurements-form-input-groups/group-multiple.vue